import { render, staticRenderFns } from "./YetkiGecisiDugmesi.vue?vue&type=template&id=c15f3a96&scoped=true"
import script from "./YetkiGecisiDugmesi.vue?vue&type=script&lang=ts"
export * from "./YetkiGecisiDugmesi.vue?vue&type=script&lang=ts"
import style0 from "./YetkiGecisiDugmesi.vue?vue&type=style&index=0&id=c15f3a96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15f3a96",
  null
  
)

export default component.exports